/* 365 Jerseys — Premium Blog Article
   Drop into: assets/premium-blog-article.js */
(function () {
  'use strict';

  /* ---------- Player vs Fan Slider ---------- */
  function initSliders() {
    document.querySelectorAll('[data-pba-slider]').forEach(function (slider) {
      var frame = slider.querySelector('.pba-slider-frame');
      var clip = slider.querySelector('[data-pba-clip]');
      var handle = slider.querySelector('[data-pba-handle]');
      var afterImg = clip.querySelector('img');
      if (!frame || !clip || !handle) return;

      function setFrameWidth() {
        afterImg.style.width = frame.offsetWidth + 'px';
      }
      setFrameWidth();
      window.addEventListener('resize', setFrameWidth);

      function setPosition(percent) {
        percent = Math.max(0, Math.min(100, percent));
        clip.style.width = percent + '%';
        handle.style.left = percent + '%';
        handle.setAttribute('aria-valuenow', Math.round(percent));
      }

      function percentFromEvent(clientX) {
        var rect = frame.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      var dragging = false;

      function onMove(clientX) {
        setPosition(percentFromEvent(clientX));
      }

      handle.addEventListener('pointerdown', function (e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });
      frame.addEventListener('pointerdown', function (e) {
        dragging = true;
        onMove(e.clientX);
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        onMove(e.clientX);
      });
      window.addEventListener('pointerup', function () { dragging = false; });

      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(handle.style.left) || 50;
        if (e.key === 'ArrowLeft') { setPosition(current - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPosition(current + 5); e.preventDefault(); }
      });

      setPosition(50);
    });
  }

  /* ---------- FAQ Accordion ---------- */
  function initFaq() {
    document.querySelectorAll('[data-pba-faq-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pba-faq-item');
        var answer = item.querySelector('.pba-faq-a');
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        answer.style.maxHeight = expanded ? '0px' : answer.scrollHeight + 'px';
      });
    });
  }

  /* ---------- Table of Contents ---------- */
  function initToc() {
    var list = document.getElementById('pba-toc-list');
    if (!list) return;
    var headings = document.querySelectorAll('.pba-prose h2, .pba-block-heading');
    if (!headings.length) {
      var toc = document.getElementById('pba-toc');
      if (toc) toc.style.display = 'none';
      return;
    }
    var links = [];
    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'pba-section-' + i;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
      links.push({ el: h, link: a });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var match = links.find(function (l) { return l.el === entry.target; });
        if (!match) return;
        if (entry.isIntersecting) {
          links.forEach(function (l) { l.link.classList.remove('is-active'); });
          match.link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });

    headings.forEach(function (h) { observer.observe(h); });
  }

  /* ---------- Copy Link ---------- */
  function initCopyLink() {
    document.querySelectorAll('[data-pba-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-url');
        navigator.clipboard.writeText(url).then(function () {
          var original = btn.innerHTML;
          btn.innerHTML = '✓';
          setTimeout(function () { btn.innerHTML = original; }, 1500);
        });
      });
    });
  }

  /* ---------- Scroll Reveal ---------- */
  function initReveal() {
    var targets = document.querySelectorAll(
      '.pba-callout, .pba-proscons, .pba-compare, .pba-faq, .pba-gallery, .pba-slider-wrap, .pba-summary'
    );
    targets.forEach(function (t) { t.classList.add('pba-reveal'); });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    targets.forEach(function (t) { observer.observe(t); });
  }

  function init() {
    initSliders();
    initFaq();
    initToc();
    initCopyLink();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();